const tabsMenuHandler = (parent, descEl, mobEl, contentEl) => {
    let tabsTitleDesktop = parent.querySelectorAll(descEl)
    let tabsTitleMobile = parent.querySelectorAll(mobEl)
    let tabContent = parent.querySelectorAll(contentEl)
    let tabStart = 0

    window.addEventListener('resize', showFirstTab)

    let showFirstTab = () => {
        try {
            if (window.innerWidth >= 768) {
                tabsTitleDesktop[tabStart].classList.add('tabs__active')
                tabContent[tabStart].classList.add('tabs__active')
            } else {
                // tabsTitleMobile[tabStart].classList.add('tabs__active')
                // tabContent[tabStart].classList.add('tabs__active')
            }
        } catch (e) {
            console.log('No tabs on the page')
        }
    }

    parent.addEventListener('click', (e) => {
        let target = e.target

        if (target.closest(descEl)) {
            tabsOpen(tabsTitleDesktop, descEl, target)
        } else if (target.closest(mobEl)) {
            tabsOpen(tabsTitleMobile, mobEl, target)
        }
    })

    let tabsOpen = (arr, el, target) => {
        let tab = target.closest(el)
        console.log(arr)
        for (let j = 0; j < arr.length; j++) {
            if (arr[j] != tab) {
                arr[j].classList.remove('tabs__active')
                console.log(tabContent[j])
                tabContent[j].classList.remove('tabs__active')
            }
        }

        let tabCount = tab.getAttribute('data-tab')
        tab.classList.add('tabs__active')
        tabContent[tabCount].classList.add('tabs__active')
    }

    showFirstTab()
}

export default tabsMenuHandler
